import { IconButton, Popover } from '@zillow/constellation-10';
import { IconInfoOutline } from '@zillow/constellation-icons';

import type { ReactNode } from 'react';
import type { PopoverPropsInterface } from '@zillow/constellation-10';

type Props = {
  handleOnOpen?: () => void;
  tone?: PopoverPropsInterface['tone'];
  header: ReactNode;
  body: ReactNode;
  onOpenDataEventId?: string;
};

const RMWPopover = ({ handleOnOpen, tone = 'neutral', header, body, onOpenDataEventId }: Props) => {
  return (
    <Popover
      tone={tone}
      header={header}
      body={body}
      onOpenChange={(open) => open && handleOnOpen?.()}
      placement="top"
      trigger={
        <IconButton
          emphasis="bare"
          shape="circle"
          size="md"
          title="More information"
          tone="brand"
          icon={<IconInfoOutline />}
          css={{ height: 'auto', backgroundColor: 'transparent' }}
          data-eventid={onOpenDataEventId}
        />
      }
    />
  );
};

export default RMWPopover;
